import { fetchJurisdictionsByPlanId } from './fetchJurisdictionsByPlanIdThunk';
export default fetchJurisdictionsByPlanId;
